import Vue from 'vue';
import firebase from 'firebase';
import Buefy from 'buefy';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faUserSecret, faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import 'buefy/dist/buefy.css';

import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';

library.add(faUserSecret, faAngleDown);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(Buefy, {
  defaultIconComponent: 'vue-fontawesome',
  defaultIconPack: 'fas',
});

Vue.config.productionTip = false;

let app = '';

const config = {
  apiKey: 'AIzaSyBGMaAG9RhFRqkA7kxzbyDRxCbk4Qzb-3g',
  authDomain: 'uniting-culture-app.firebaseapp.com',
  databaseURL: 'https://uniting-culture-app.firebaseio.com',
  projectId: 'uniting-culture-app',
  storageBucket: 'uniting-culture-app.appspot.com',
  messagingSenderId: '986211144769',
  appId: '1:986211144769:web:fa11d525076eeafa9d22c0',
  measurementId: 'G-KK0CSNTW4Q',
};

firebase.initializeApp(config);

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App),
    }).$mount('#app');
  }
});
